module.exports = __webpack_public_path__ + "img/playstore.db9b21a1.png";